/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import {useLayoutEffect, useState} from "react";
import {ScriptStatus} from "./ScriptStatus";
import {useScriptTracker} from "./useScriptTracker";

export function useScriptStatus(id: string): ScriptStatus {
  const {statusOf} = useScriptTracker();
  const [status, setStatus] = useState<ScriptStatus>(ScriptStatus.LOADING);

  useLayoutEffect(() => {
    console.info("useScriptStatus effect running");
    statusOf(id)?.then(setStatus);
  }, [id]);

  return status;
}
